module.exports = __webpack_public_path__ + "img/ic_alert_triangle.3aaadcef.svg";